import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";
import themeColors from "@MasterBluePrint/Styles/variables";
import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    buyBoxWrapper?: InjectableCss;
    mobileBuyBoxWrapper?: InjectableCss;
    mobileGridItemShow?: HiddenProps;
    desktopGridItemShow?: HiddenProps;
    specificationTabs: GridItemProps;
    plnr?: InjectableCss;
}

export const viewStyles: ProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
            padding-top:15px;
            .hide-element {
                display: none;
            }
            .qty-container-new {
                width: 9.2rem;
                max-width: 9.2rem;
            }
            @media (min-width: 768px) and (max-width: 991px) {
                .qty-wrapper {
                    flex-basis: 50%;
                    max-width: 50%;
                }
            }
        `,
    },
    topGridItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            padding-left:30px;
            order:1;
            @media (max-width: 991px) {
                padding: 15px 30px;
                order:2;
            }
        `,
    },
    middleGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            order:2;
            @media (max-width: 991px) {
                padding: 15px 30px;
                order:1;
            }
        `,
    },
    specificationTabs: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding-left:30px;
            order:3;
            @media (max-width: 991px) {
                padding: 15px 30px;
            }
        `,
    },
    bottomGridItem: {
        width: [12, 12, 12, 12, 12],
    },
    mobileGridItemShow: {
        above: "md",
        css: css`
            width: 100%;
            direction: ltr;
            position: relative;

            &.has-image-badges {
                > div {
                    padding-top: 25px;
                }
            }
            &.mob-wrapper-first {
                background: #f7F9FA;
                margin: 0;
            }

            .pre-owned.certified,
            .open.box {
                position: absolute;
                top: 0;
                right: 11px;
                width: auto;
            }
            
            div[data-test-selector="imageBadges"] img {
                width: 134px !important;
            }

            &.pdp-middle-container-mobile {
                > div {
                    > div:nth-child(3) {
                        > div {
                            > div:first-child {
                                > div[class^="Wrapper"], div[class*="Wrapper"]{                                        
                                    display: flex;
                                    flex-direction: column;
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    rightColumnGridItem: {
        width: [0, 0, 0, 3, 3],
        css: css`
        display: flex;
        flex-direction: row;
        align-items:flex-start;

        .unitlabeluk {
            span[data-test-selector="productPrice_unitNetPrice"] {
                font-size: 1.25rem;
                color: ${themeColors.colorPrimary} !important;
            }
        }
        .hide-element {
            display: none;
        }
        .qty-container-new {
            width: 9rem !important;
            max-width: 9rem;
        }
        .yesFlagYesOther {
            margin-top:-26px;
        }
        @media (max-width: 1300px) {
            .qty-wrapper {
                flex-basis: 100%;
                max-width: 100%;
            }
        }
        @media (min-width: 768px) and (max-width: 991px) {
            .qty-wrapper {
                flex-basis: 50%;
                max-width: 50%;
            }
        }
        direction: ltr;
        > div > div:first-child {
            background-color: #f7F9FA;
            padding: 1.5rem;
            > div:nth-child(5) {
                @media (max-width: 1200px) {
                    > div:first-child {
                        display: flex;
                        flex-direction: column;
                        }
                }
                
            }
        }
        
        &.has-image-badges {
            > div {
                padding-top: 4.2em;
            }
        }

        .pre-owned.certified,
        .open.box {
            position: absolute;
            top: -6px;
            right: 21px;
        }
        
        div[data-test-selector="imageBadges"] img {
            width: 134px !important;
        }
        `,
    },
    buyBoxWrapper: {
        css: css`
            max-width: 100%;
            max-height: 100%;
            position: sticky;
            top: 75px;
            display: block;
            margin-bottom: 40px;
            color: rgb(34, 34, 34);
            z-index: 998;
            width: 100%;
            direction: ltr;
        `,
    },
    mobileBuyBoxWrapper: {
        css: css`
            @media (min-width: 991px) {
                display:none;
            }
            display:block;
            width:100%;
            margin:0;
            background-color: #f7F9FA;
            position:fixed;
            bottom:0;
            z-index:999999;
            box-shadow:0px -9px 9px rgba(0, 0, 0, .09);
        `,
    },
    leftColumnInnerContainer: {
        css: css`
            direction: ltr;
        `,
    },
    plnr: {
        css: css`
            .qty-wrapper.hide-element ~ div > div:first-child .adjust-addtolist{
                text-align: left;
                margin-bottom: 2rem;
                margin-top: 1.75rem;
            }
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    const [hasImageBadges, setHasImageBadges] = useState(false);
    let featureFlags: string[] = ["TEUS-8610"];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const isFeatureTEUS8610On = flagValues["TEUS-8610"];

    const checkImageBadges = () => {
        const badgeComponent = document.querySelector('[data-test-selector="imageBadges"] img');
        if (badgeComponent) {
            setHasImageBadges(true);
        }
    };

    React.useEffect(() => {
        checkImageBadges();
    }, []);

    const rightColumnClass = `${hasImageBadges ? "has-image-badges" : ""}`;
    
    return (
        <GridContainer {...styles.container} {...styles.plnr}>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn" className="pdp-left-column">
                <GridContainer {...styles.leftColumnInnerContainer}>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem>

                    <GridItem {...styles.middleGridItem} className="pdp-middle-container">
                        <Zone contentId={props.id} zoneName="Content1"/>
                    </GridItem>
                    <StyledWrapper {...styles.mobileBuyBoxWrapper} id="mobileBuyBoxWrapper">
                        <Hidden {...styles.mobileGridItemShow} className={`mob-wrapper-first ${rightColumnClass}`}>
                            <GridItem {...styles.bottomGridItem}>
                                <Zone contentId={props.id} zoneName="Content2" />
                            </GridItem>
                        </Hidden>
                        {isFeatureTEUS8610On &&
                            <Hidden {...styles.mobileGridItemShow} className={`mob-wrapper-first ${rightColumnClass}`}>
                                <GridItem {...styles.bottomGridItem}>
                                    <Zone contentId={props.id} zoneName="Content5" />
                                </GridItem>
                            </Hidden>
                        }
                    </StyledWrapper>
                    <GridItem {...styles.specificationTabs}>
                        <Zone contentId={props.id} zoneName="specificationTabs" />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.rightColumnGridItem} className={`pdp-right-column ${rightColumnClass}`}>
                <StyledWrapper {...styles.buyBoxWrapper}>                    
                    <Zone contentId={props.id} zoneName="Content2" />
                    {isFeatureTEUS8610On &&
                        <Zone contentId={props.id} zoneName="Content5" />
                    }
                </StyledWrapper>
            </GridItem>

            <Hidden {...styles.mobileGridItemShow}>
                <GridItem width={12}>
                    <Zone contentId={props.id} zoneName="Content4" />
                </GridItem>
            </Hidden>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
